import React, { useState, useEffect } from 'react';
import Refresh from '../Components/refresh/refresh';
import '../css/DailyAppointmentPage.css';
import '../css/loader.css';
import '../css/process.css';
import Header from '../Components/Header/header';
import { useNavigate } from 'react-router-dom';
import { useDefLocation } from '../Context/LocationProvider'; // Import the LocationContext
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from '../Context/Config';
import usePinLock from '../Utils/pinLock'; // Import the PIN lock hook
import { checkTokenAndNavigate } from "../Utils/checkNavigate";
import { refreshToken } from '../Context/RefreshToken';
import axios from 'axios';
import Swal from "sweetalert2";
import { showSuccess, showError, showCustomAlert, showConfirmAction } from '../Utils/swal';
import Modal from "react-modal";
import FileDownloadModal from '../Components/fileModal/fileModal'; // import the modal component
import PhotoViewer from '../Components/photoViewer/photo'; // import the modal component
import EmailPopup from "../Components/Email/sendEmail";
import { formattingDate, formatDateString } from "../Utils/formatDate";
import { useAutoTokenRefresh } from "../Context/refresh";
import PatientNotificationPopup from '../Components/Notification/sendNotification';
import { rsisurgeonsOptions, segsurgeonsOptions } from '../Utils/Options';
import { handleSort } from '../Utils/sort';
import PCMPopup from '../Components/PCM/PCMPopup';
import Config from '../Context/Config';

Modal.setAppElement("#root"); // Required for accessibility
function App() {
    const [locations, setLocations] = useState([]); // All locations from the API
    const [providers, setProviders] = useState([]); // Providers for selected location
    const [selectedProvider, setSelectedProvider] = useState(""); // Selected provider
    const { defaultLocation, setDefaultLocation } = useDefLocation(); // Context for location state
    const [openHistory, setOpenHistory] = useState(false);

    const [historyData, setHistoryData] = useState({
        createdBy: "",
        createdAt: "",
        editedBy: []
    });
    const [pageTitle, setPageTitle] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [patient, setPatient] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [filteredSurgeryData, setFilteredSurgeryData] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [surgeryAppointments, setSurgeryAppointments] = useState([]);
    const type = localStorage.getItem("digital-form-dept-type") || "surgical";
    const [isLoading, setIsLoading] = useState(false); // Loading state
    const [isLoading1, setIsLoading1] = useState(false); // Loading state
    const [isLoading3, setIsLoading3] = useState(false); // Loading state
    const [isLoading5, setIsLoading5] = useState(false); // Loading state
    const [isDepartmentsFetched, setIsDepartmentsFetched] = useState(false);
    const [openedViaButton, setOpenedViaButton] = useState(false);
    const navigate = useNavigate();
    useAutoTokenRefresh({ navigate, intervalMs: 5 * 60 * 1000 });
    const [openPhotoChart, setOpenPhotoChart] = useState(null);
    const [openNotificationBox, setOpenNotificationBox] = useState(null);
    const [tableVisibility, setTableVisibility] = useState('table1');
    const [coverageModalOpen, setCoverageModalOpen] = useState(false);
    const [coverageModalData, setCoverageModalData] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [modalData, setModalData] = useState({});
    const [openSurgicalModal, setOpenSurgicalModal] = useState(false);
    const [openInjectionModal, setOpenInjectionModal] = useState(false);
    const [template, setTemplate] = useState('')
    const [refreshKey, setRefreshKey] = useState(0);
    const [reviewKey, setReviewKey] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [fileData, setFileData] = useState(null);
    const [isLoading6, setIsLoading6] = useState(false); // Loading state
    const [isSubmittingSurgicalForm, setIsSubmittingSurgicalForm] = useState(false);
    const [isSubmittingInjectionForm, setIsSubmittingInjectionForm] = useState(false);
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const surgicalLocations = {
        'rsi': ['Andrews Institute', 'Emerald Coast Surgery Center', 'Summit Surgery Center', 'Baldwin Co Surgery Center'],
    }
    const surgeons = {
        'rsi': rsisurgeonsOptions.map(opt => opt.value),
        'seg': segsurgeonsOptions.map(opt => opt.value),
    }
    const practiceForSurgery = localStorage.getItem("digital-form-dept-practice")
    const currentMonth = new Date().getMonth(); // 0-based index
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(months[currentMonth]);
    const [surgicalLocation, setSurgicalLocation] = useState('All');
    const [selectedsurgeon, setSurgeon] = useState('All');
    const [showPopup, setShowPopup] = useState(false);
    const [popupData, setPopupData] = useState({});
    const [showPCMPopup, setShowPCMPopup] = useState(false);
    const [showPCMSendPopup, setShowPCMSendPopup] = useState(false);
    const [pcmPopupData, setPcmPopupData] = useState({});
    const [pcmCommunicationMedium, setPcmCommunicationMedium] = useState('email');
    const [surgeryDateFrom, setSurgeryDateFrom] = useState(startDate);
    const [surgeryDateTo, setSurgeryDateTo] = useState(startDate);


    const sortData = (data, key, direction) => {
        const sortedData = [...data];

        sortedData.sort((a, b) => {
            // Handle date columns separately
            if (key === 'appt_date_time' || key === 'dob' || key === 'requested_time_of_surgery' || key === 'requested_date_of_surgery') {
                const dateA = new Date(a[key]);
                const dateB = new Date(b[key]);

                if (dateA < dateB) return direction === 'asc' ? -1 : 1;
                if (dateA > dateB) return direction === 'asc' ? 1 : -1;
                return 0;
            }

            // Handle other columns
            if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
            if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        return sortedData;
    };

    const handleHistory = (edited_by, created_at, created_by) => {
        try {
            // Handle null or missing values safely
            const safeEditedBy = Array.isArray(edited_by) ? edited_by : [];
            const safeCreatedBy = created_by || "Unknown";

            // Convert UTC timestamp to U.S. Central Time (HH:MM only)
            const convertToCentralTime = (utcDateString) => {
                if (!utcDateString) return "N/A";
                const date = new Date(utcDateString + "Z"); // ensure UTC
                return date.toLocaleTimeString("en-US", {
                    timeZone: "America/Chicago",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false, // 24-hour format; change to true if 12-hour needed
                });
            };

            const centralTime = convertToCentralTime(created_at);

            // Parse edited_by JSON safely
            const parsed = safeEditedBy.map((entry) => JSON.parse(entry));

            // Optionally convert edited_by times to HH:MM
            const parsedWithCentralTimes = parsed.map((obj) => {
                const [name, times] = Object.entries(obj)[0];
                const convertedTimes = times.map((t) => convertToCentralTime(t));
                return { [name]: convertedTimes };
            });

            // Update state
            setHistoryData({
                createdBy: safeCreatedBy,
                createdAt: centralTime,
                editedBy: parsedWithCentralTimes,
            });

            setOpenHistory(true);
        } catch (err) {
            console.error("Invalid edited_by JSON:", err);
            // fallback
            setHistoryData({
                createdBy: created_by || "Unknown",
                createdAt: created_at || "N/A",
                editedBy: [],
            });
            setOpenHistory(true);
        }
    };

    const sortedData = sortData(filteredData, sortConfig.key, sortConfig.direction);
    const sortedSurgeryData = sortData(filteredSurgeryData, sortConfig.key, sortConfig.direction);

    const tryRefresh = async (autoReloadBool) => {
        await refreshToken({
            navigate,
            onSuccess: (token) => console.log("Refreshed:", token),
            onError: (err) => console.error("Failed to refresh", err),
            autoReload: autoReloadBool
        });
    };

    useEffect(() => {
        setPageTitle('Appointments'); // Update the page title
    }, []);

    const { isLocked } = usePinLock(tryRefresh);

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                setIsLoading5(true)
                // Fetch departments (locations) from the API
                fetch(`${config.API_BASE_URL}/departments?practice=${localStorage.getItem("digital-form-dept-practice")}&type=${type}`, {
                    method: "GET",  // Default method is GET, but you can explicitly specify it
                    headers: {
                        "action_id": config.ACTIONID['view'], // Assuming the action_id for 'view' is set in config
                        "Content-Type": "application/json",
                        "Authorization": `${localStorage.getItem("digital-form-idtoken")}`,
                        "practice": localStorage.getItem("digital-form-dept-practice")
                    }
                }).then(async (response) => {
                    // Check if the response is successful
                    if (response.ok) {
                        const data = await response.json();
                        // Successfully fetched data, update state with locations
                        setLocations(data);
                        const storedLocation = localStorage.getItem("defaultLocation");
                        if (storedLocation) {
                            const parsedLocation = JSON.parse(storedLocation);
                            const selectedDept = data.find(
                                (location) => location.dept_id === parsedLocation
                            );
                            if (selectedDept) {
                                setDefaultLocation(selectedDept.dept_id);
                                setProviders(selectedDept.providers_list || []); // Set provider list if available

                                localStorage.setItem(
                                    "selectedLocation",
                                    JSON.stringify({
                                        id: selectedDept.dept_id,
                                        name: selectedDept.dept_name,
                                        providerList: selectedDept.providers_list || [],
                                    })
                                );
                                setSelectedProvider(""); // Reset selected provider
                                setIsDepartmentsFetched(true);
                            }
                        } // Parse the response body to JSON
                    }
                    else {
                        switch (response.status) {
                            case 401:
                                showCustomAlert(
                                    "warning",
                                    "Session Expired",
                                    "Your session has expired. Please click on 'Restore Session' to continue accessing clinic locations.",
                                    "Restore Session",
                                    () => tryRefresh(true)
                                );
                                break;

                            case 403:
                                showCustomAlert(
                                    "warning",
                                    "Access Denied",
                                    "You don't have permission to view clinic locations. Please contact your administrator if this seems incorrect."
                                );
                                break;

                            case 500:
                                showCustomAlert(
                                    "error",
                                    "Server Error",
                                    "A server error occurred while retrieving clinic locations. Please try again later."
                                );
                                break;

                            default:
                                showCustomAlert(
                                    "error",
                                    "Error",
                                    "An unexpected error occurred while fetching clinic locations. Please try again later."
                                );
                        }

                        throw new Error("Request failed");
                    }
                })
            }
            finally {
                setIsLoading5(false)
            }
        }
        checkTokenAndNavigate(fetchLocations, tryRefresh, navigate);

    }, [setDefaultLocation]);

    function sendInviteHandler(chart) {
        showConfirmAction('Send Invite', 'Send Invite', async () => {
            try {
                const response = await fetch(`${config.API_BASE_URL}/invite?`, {
                    method: 'POST',
                    headers: {
                        "action_id": config.ACTIONID['view'],
                        'Content-Type': 'application/json',
                        "Authorization": localStorage.getItem("digital-form-idtoken"),
                        "practice": localStorage.getItem("digital-form-dept-practice")
                    },
                    body: JSON.stringify({
                        chart,
                        dept_id: localStorage.getItem('defaultLocation'),
                        practice: localStorage.getItem('digital-form-dept-practice')
                    }),
                });

                const data = await response.json();
                showSuccess('Sent!', data);
            } catch (error) {
                console.error('Error:', error);
                showError('Error', 'Failed to send invite.');
            }
        });
    }

    function sendPortalInviteHandler(chart, appt_id) {
        showConfirmAction('Send Portal Invite', 'Send Portal Invite', async () => {
            try {
                const response = await fetch(`${config.API_BASE_URL}/notifications/send_invite?`, {
                    method: 'POST',
                    headers: {
                        "action_id": config.ACTIONID['edit'],
                        'Content-Type': 'application/json',
                        "Authorization": localStorage.getItem("digital-form-idtoken"),
                        "practice": localStorage.getItem("digital-form-dept-practice")
                    },
                    body: JSON.stringify({
                        chart,
                        dept_id: localStorage.getItem('defaultLocation'),
                        practice: localStorage.getItem('digital-form-dept-practice'),
                        appt_id: appt_id
                    }),
                });

                if (!response.ok) {
                    let errorMessage = 'Something went wrong';
                    try {
                        const errData = await response.json();
                        errorMessage = errData.message || JSON.stringify(errData);
                    } catch (e) {
                        errorMessage = response.statusText;
                    }
                    throw new Error(`Error ${response.status}: ${errorMessage}`);
                }

                const data = await response.json();
                filteredData.forEach((item) => {
                    if (item.patientid === chart) {
                        item.portal_invite = data.date;
                    }
                });
                showSuccess('Sent!', 'Portal invite sent successfully.');
            } catch (error) {
                console.error('Error:', error);
                showError('Error', error.message || 'Failed to send invite.');
            }
        });
    }

    const consentEmail = async (name, chart, appointmentID, s3_path, template) => {
        const data = {
            name: name,
            chart: chart,
            s3Path: s3_path,
            template: template,
            appointmentId: appointmentID
        };
        setPopupData(data);
        setShowPopup(true);
    }

    const handlePCMClick = (item) => {
        setPcmPopupData({
            name: item.name,
            chart: item.patientid,
            appointmentid: item.appt_id
        });
        setShowPCMPopup(true);
    };

    const handleFillFromTab = () => {
        navigate(`/consent/${pcmPopupData.chart}/${pcmPopupData.appointmentid}`, {
            state: { openedViaButton: true, show_pcm: true }
        });
    };

    const handleSendCopyToPatient = () => {
        setShowPCMSendPopup(true);
    };

    useEffect(() => {

        const fetchDataAndConsent = async () => {
            try {
                setIsLoading(true);
                setPatient("");
                // Format the appointment date
                const formattedDate = formatDate(startDate);

                // Fetch appointments
                const appointmentsResponse = await axios.post(
                    `${config.API_BASE_URL}/appointments`,
                    {
                        departmentid: defaultLocation,
                        providerid: selectedProvider,
                        apptdate: formattedDate,
                    },
                    {
                        headers: {
                            "action_id": config.ACTIONID['view'], // Assuming the action_id for 'view' is set in config
                            "Content-Type": "application/json",
                            "Authorization": `${localStorage.getItem("digital-form-idtoken")}`,
                            "practice": localStorage.getItem("digital-form-dept-practice")
                        },
                    }
                );

                // Handle appointments response
                if (appointmentsResponse.status === 200) {

                    const appointmentsData = appointmentsResponse.data.appointments;

                    if (appointmentsData !== "not found") {
                        setAppointments(appointmentsData);
                        setFilteredData(appointmentsData);

                        // Fetch and merge consent data if location matches the special location
                        try {
                            setIsLoading1(true);
                            // const appointmentIds = appointmentsData.map(appt => appt.appt_id);
                            // const charts = appointmentsData.map(appt => appt.patientid);
                            // const consentResponse = await axios.post(
                            //     `${config.API_BASE_URL}/consent_details`,
                            //     {
                            //         apptdate: formattedDate,
                            //         appt_ids: appointmentIds,
                            //         charts: charts,
                            //         departmentid: defaultLocation,
                            //         practice: `${localStorage.getItem("digital-form-dept-practice")}`
                            //     },
                            //     {
                            //         headers: {
                            //             "action_id": config.ACTIONID["view"], // Same headers for consent_details API
                            //             "Content-Type": "application/json",
                            //             "Authorization": `${localStorage.getItem("digital-form-idtoken")}`,
                            //             "practice": localStorage.getItem("digital-form-dept-practice")
                            //         },
                            //     }
                            // );

                            // if (consentResponse.status === 200) {
                            const fetchedConsentData = appointmentsResponse.data.consentResponse;

                            // Merge consent with appointments
                            const mergedData = appointmentsData.map((appointment) => {
                                const consentData = fetchedConsentData[appointment.patientid];
                                return {
                                    ...appointment,
                                    app_status: consentData
                                        ? consentData.app_status === "Not Installed" ?
                                            "Not Installed" : "Installed" : "Not Installed",
                                    surgery_forms: consentData
                                        ? consentData.surgery_forms
                                        : false,
                                    patient_registration: consentData?.patient_registration === false
                                        ? 'Check Registration'
                                        : consentData?.patient_registration,
                                    injection_consent: consentData.injection_consent ? consentData.injection_consent : 'Not Fetched',
                                    intake_forms: consentData.intake_forms,
                                    form_status: consentData.form_status,
                                    freeflow_score:
                                        consentData && consentData.freeflow_score !== null
                                            ? consentData.freeflow_score
                                            : null,
                                    score_color:
                                        consentData && consentData.freeflow_score !== null
                                            ? consentData.score_color
                                            : null,
                                    optos: consentData?.optos || 'Not Opted',
                                    abn: consentData?.abn || 'ABN Not Interested',
                                    invite_sent: consentData?.invite_sent || 'No Invite Sent',
                                    pcm: consentData?.pcm || 'PCM Not Consented',
                                    flagging: consentData?.flagging || 'No Data',
                                    optos_consent_required : consentData?.optos_consent_required || false,
                                    portal_invite: consentData?.portal_invite || 'No Portal Invite Sent',
                                    portal_status: consentData?.portal_status || 'Portal Not Registered',
                                };
                            });

                            setAppointments(mergedData);
                            setFilteredData(mergedData);
                            // }
                            // else if (consentResponse.status === 401) {
                            //     showCustomAlert(
                            //         "warning",
                            //         "Session Expired",
                            //         "Your session has expired. Please click on 'Restore Session' to access appointment consent data.",
                            //         "Restore Session",
                            //         () => tryRefresh(true)
                            //     );
                            // } else if (consentResponse.status === 403) {
                            //     showCustomAlert(
                            //         "error",
                            //         "Access Denied",
                            //         "You are not authorized to view appointment consent information."
                            //     );
                            // } else {
                            //     showCustomAlert(
                            //         "error",
                            //         "Consent Retrieval Error",
                            //         "We encountered a problem while fetching consent data. Please try again later."
                            //     );
                            // }
                        }
                        finally {
                            setIsLoading1(false);
                        }
                    } else {
                        console.warn("No appointments found.");
                        setAppointments([]);
                        setFilteredData([]);
                    }
                }
            }
            catch (error) {
                console.error("Error fetching appointments:", error);
                if (error.response) {
                    const { status } = error.response;

                    if (status === 401) {
                        showCustomAlert(
                            "warning",
                            "Session Expired",
                            "Your session has expired. Please click on 'Restore Session' to access appointments.",
                            "Restore Session",
                            () => tryRefresh(true)
                        );
                    } else if (status === 403) {
                        showCustomAlert(
                            "error",
                            "Access Denied",
                            "You are not authorized to view appointment data."
                        );
                    } else {
                        showCustomAlert(
                            "error",
                            "Appointments Error",
                            "We couldn't retrieve your appointments at this time. Please try again later."
                        );
                    }
                } else {
                    // Network or unexpected errors
                    showCustomAlert(
                        "error",
                        "Network Error",
                        "Unable to connect to the server. Please check your internet connection and try again."
                    );
                }
                setAppointments([]);
                setFilteredData([]);
            }
            finally {
                setIsLoading(false);
            }
        };
        const fetchUnuploadedSurgData = async () => {
            try {
                setIsLoading(true);
                setPatient("");
                // Fetch appointments
                if (practiceForSurgery === 'rsi') {
                    const surgeryResponse = await axios.post(
                        `${config.API_BASE_URL}/surgical/surgery_appts`,
                        {
                            "practice": `${localStorage.getItem("digital-form-dept-practice")}`,
                            "month": selectedMonth,
                            "surgeon": selectedsurgeon,
                            "center": surgicalLocation,
                            "year": selectedYear
                        },
                        {
                            headers: {
                                "action_id": config.ACTIONID['view'], // Assuming the action_id for 'view' is set in config
                                "Content-Type": "application/json",
                                "Authorization": `${localStorage.getItem("digital-form-idtoken")}`,
                                "practice": localStorage.getItem("digital-form-dept-practice")
                            },
                        }
                    );

                    // Handle appointments response
                    if (surgeryResponse.status === 200) {
                        const surgeryData = surgeryResponse.data;

                        if (surgeryData !== "not found") {
                            setSurgeryAppointments(surgeryData);
                            setFilteredSurgeryData(surgeryData);

                        } else {
                            console.warn("No unuploaded surgical appointments found.");
                            setSurgeryAppointments([]);
                            setFilteredSurgeryData([]);
                        }
                    }

                }
                else {
                    const formatDateForAPI = (date) => {
                        if (!date) return null;
                        return date.toISOString().split('T')[0];
                    };
                    const surgeryResponse = await axios.post(
                        `${config.API_BASE_URL}/surgical/surgery_consents`,
                        {
                            "practice": `${localStorage.getItem("digital-form-dept-practice")}`,
                            "surgeryDateFrom": formatDateForAPI(surgeryDateFrom),
                            "surgeryDateTo": formatDateForAPI(surgeryDateTo),
                            "year": selectedYear
                        },
                        {
                            headers: {
                                "action_id": config.ACTIONID['view'], // Assuming the action_id for 'view' is set in config
                                "Content-Type": "application/json",
                                "Authorization": `${localStorage.getItem("digital-form-idtoken")}`,
                                "practice": localStorage.getItem("digital-form-dept-practice")
                            },
                        }
                    );

                    // Handle appointments response
                    if (surgeryResponse.status === 200) {
                        const surgeryData = surgeryResponse.data;

                        if (surgeryData !== "not found") {
                            setSurgeryAppointments(surgeryData);
                            setFilteredSurgeryData(surgeryData);

                        } else {
                            console.warn("No unuploaded surgical appointments found.");
                            setSurgeryAppointments([]);
                            setFilteredSurgeryData([]);
                        }
                    }
                }
            }
            catch (error) {
                console.error("Error fetching appointments:", error);
                if (error.response) {
                    const { status } = error.response;

                    if (status === 401) {
                        showCustomAlert(
                            "warning",
                            "Session Expired",
                            "Your session has expired. Please click on 'Restore Session' to access surgical appointments.",
                            "Restore Session",
                            () => tryRefresh(true)
                        );
                    } else if (status === 403) {
                        showCustomAlert(
                            "error",
                            "Access Denied",
                            "You are not authorized to view appointment data."
                        );
                    } else {
                        showCustomAlert(
                            "error",
                            "Appointments Error",
                            "We couldn't retrieve your appointments at this time. Please try again later."
                        );
                    }
                } else {
                    // Network or unexpected errors
                    showCustomAlert(
                        "error",
                        "Network Error",
                        "Unable to connect to the server. Please check your internet connection and try again."
                    );
                }
                setSurgeryAppointments([]);
                setFilteredSurgeryData([]);

            }
            finally {
                setIsLoading(false);
            }
        };
        if (isDepartmentsFetched) {
            if (tableVisibility === 'table1') {
                fetchDataAndConsent();
            }
            else if (tableVisibility === 'table2' || tableVisibility === 'table3') {
                fetchUnuploadedSurgData()
            }

        }
    }, [isDepartmentsFetched, selectedProvider, defaultLocation, startDate, tableVisibility, refreshKey, selectedMonth, selectedsurgeon, surgicalLocation, reviewKey, selectedYear, surgeryDateFrom, surgeryDateTo]);

    const handleProviderChange = (event) => {
        setSelectedProvider(event.target.value);
    };

    const handleLocation = (event) => {
        const selectedValue = event.target.value;
        setDefaultLocation(selectedValue);
        if (selectedValue) {
            setIsDepartmentsFetched(false);
            const parsedLocation = JSON.parse(selectedValue);
            const selectedDept = locations.find(
                (location) => location.dept_id === parsedLocation
            );
            if (selectedDept) {
                setDefaultLocation(selectedDept.dept_id);
                setProviders(selectedDept.providers_list || []); // Set provider list if available

                localStorage.setItem(
                    "selectedLocation",
                    JSON.stringify({
                        id: selectedDept.dept_id,
                        name: selectedDept.dept_name,
                        providerList: selectedDept.providers_list || [],
                    })
                );
                setSelectedProvider(""); // Reset selected provider
                setIsDepartmentsFetched(true);
            }
        } // Parse the response body to JSON
    };

    const handleSend = async (item) => {
        try {
            const response = await fetch(`${config.API_BASE_URL}/surgical/send_consent`, {
                method: "POST",
                headers: {
                    "action_id": config.ACTIONID['view'], // Assuming the action_id for 'view' is set in config
                    "Content-Type": "application/json",
                    Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                    "practice": localStorage.getItem("digital-form-dept-practice")
                },
                body: JSON.stringify(
                    {
                        data: item
                    }
                ),
            });
            if (!response.ok) {
                // Handle different error scenarios
                switch (response.status) {
                    case 401:
                        showCustomAlert(
                            "warning",
                            "Session Expired",
                            "Your session has expired. Please click on 'Restore Session' to access patient data.",
                            "Restore Session",
                            () => tryRefresh(false)
                        );
                        break;

                    case 403:
                        showCustomAlert(
                            "error",
                            "Access Denied",
                            "You do not have permission to send email."
                        );
                        break;

                    case 500:
                        showCustomAlert(
                            "error",
                            "Server Error",
                            "A server error occurred while sending an email. Please try again later."
                        );
                        break;

                    default:
                        showCustomAlert(
                            "error",
                            "Unexpected Error",
                            "An unexpected error occurred while sending an email. Please try again."
                        );
                }
                return; // Exit function for error cases
            }
            else if (response.ok) {
                showSuccess('Sent!', 'Email task is created.');
            }

        } catch (error) {
        }
    };

    const formatDate = (unformattedDate) => {
        try {
            const formattedDate = formattingDate(unformattedDate);
            return formattedDate
        } catch (err) {
            console.error('Error formatting date:', err.message);
        }
    };

    function toTitleCase(name) {
        return name
            .toLowerCase()
            .split(' ')
            .map(word => {
                // Capitalize the word unless it's "OD" or "MD"
                if (word !== 'od' && word !== 'md' && word !== 'do') {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                }
                else {
                    return word.toUpperCase()
                }
            })
            .join(' '); // Join the words back into a single string
    }

    const openModalWithData = (chart, apptID, update_center = false, isInjection = false) => {
        const date = startDate.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        });
        const formattedDate = date.replace(/\//g, '');
        setModalData({
            chart: chart,
            apptId: apptID,
            formattedDate: formattedDate,
            update_center: update_center,
            isInjection: isInjection
        });
        if (isInjection) {
            setOpenInjectionModal(true);
        }
        else {
            setOpenSurgicalModal(true);
        }
    };

    const showFileDownloadAlert = (
        icon,
        title,
        text,
        confirmButtonText = "Close",
        onConfirm = null,
        onClose = null
    ) => {
        Swal.fire({
            icon,
            title,
            text,
            confirmButtonText,
        }).then((result) => {
            if (result.isConfirmed && typeof onConfirm === "function") {
                onConfirm();
            }
            if (typeof onClose === "function") {
                onClose();
            }
        });
    };

    const ModalForFiles = async (apptID, review = false, form_type) => {
        setOpenModal(true);
        setIsLoading6(true);

        try {
            const response = await fetch(`${config.API_BASE_URL}/s3_files`, {
                method: "POST",
                headers: {
                    "action_id": config.ACTIONID['view'],
                    "Content-Type": "application/json",
                    Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                    "practice": localStorage.getItem("digital-form-dept-practice")
                },
                body: JSON.stringify({
                    apptId: apptID,
                    form_type: form_type
                }),
            });

            if (!response.ok) {
                setOpenModal(false);
                setIsLoading6(false);

                switch (response.status) {
                    case 401:
                        showFileDownloadAlert(
                            "warning",
                            "Session Expired",
                            "Your session expired. Please click on 'Restore Session'.",
                            "Restore Session",
                            () => tryRefresh(false)
                        );
                        break;

                    case 403:
                        showFileDownloadAlert(
                            "error",
                            "Access Denied",
                            "You don't have permission to download these files.",
                            "Close",
                            null);
                        break;

                    case 500:
                        showFileDownloadAlert(
                            "error",
                            "Server Error",
                            "A server error occurred while downloading the files. Please try again later.",
                            "Close",
                            null
                        );
                        break;

                    default:
                        showFileDownloadAlert(
                            "error",
                            "Unexpected Error",
                            "Something went wrong while downloading the files. Please try again.",
                            "Close",
                            null
                        );
                }

                return;
            }
            const res = await response.json();
            const data = {
                files: res,
                apptID: apptID,
                review: review,
                form_type: form_type
            }
            setFileData(data);
            setIsLoading6(false);

        } catch (error) {
            console.error("Fetch failed:", error);
            setOpenModal(false);
            setIsLoading6(false);
            showFileDownloadAlert(
                "error",
                "Unexpected Error",
                "Something went wrong while downloading the files. Please try again.",
                "Close",
                null
            );
        }
    };

    const ModalForSurgery = async (key) => {
        setOpenModal(true);
        setIsLoading6(true);

        try {
            const response = await fetch(`${config.API_BASE_URL}/surgical/s3_files_surgery`, {
                method: "POST",
                headers: {
                    "action_id": config.ACTIONID['view'],
                    "Content-Type": "application/json",
                    Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                    "practice": localStorage.getItem("digital-form-dept-practice")
                },
                body: JSON.stringify({
                    key: key
                }),
            });

            if (!response.ok) {
                setOpenModal(false);
                setIsLoading6(false);

                switch (response.status) {
                    case 401:
                        showFileDownloadAlert(
                            "warning",
                            "Session Expired",
                            "Your session has expired. Please click on 'Restore Session' to continue downloading files.",
                            "Restore Session",
                            () => tryRefresh(false)
                        );
                        break;

                    case 403:
                        showFileDownloadAlert(
                            "error",
                            "Access Denied",
                            "You don't have permission to download these files.",
                            "Close",
                            null
                        );
                        break;

                    case 500:
                        showFileDownloadAlert(
                            "error",
                            "Server Error",
                            "A server error occurred while downloading the files. Please try again later.",
                            "Close",
                            null
                        );
                        break;

                    default:
                        showFileDownloadAlert(
                            "error",
                            "Unexpected Error",
                            "Something went wrong while downloading the files. Please try again.",
                            "Close",
                            null
                        );
                }

                return;
            }
            const res = await response.json();
            const data = {
                files: res
            }
            setFileData(data);
            setIsLoading6(false);

        } catch (error) {
            console.error("Fetch failed:", error);
            setOpenModal(false);
            setIsLoading6(false);
            showFileDownloadAlert(
                "error",
                "Unexpected Error",
                "Something went wrong while downloading the files. Please try again.",
                "Close",
                null
            );
        }
    };


    const handleExpandClick = (formName, chart, apptID, provider_type, shouldValidate = false) => {
        const showForm = (localStorage.getItem("digital-form-dept-practice") === 'seg' && provider_type === 'OD') ? true : false;
        const date = startDate.toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
        });
        const formattedDate = date.replace(/\//g, '');
        setOpenedViaButton(true);
        if (formName === 'SurgeryForm') {
            if (chart && startDate) {
                navigate(`/surgical-forms/${chart}/${formattedDate}/${apptID}`, { state: { openedViaButton: true } });
            } else {
                console.error("Chart or Date is missing");
            }
        }
        if (formName === 'InjectionConsent') {
            if (chart && startDate) {
                navigate(`/injection/${chart}/${formattedDate}/${apptID}`, { state: { openedViaButton: true, shouldValidate: shouldValidate } });
            } else {
                console.error("Chart or Date is missing");
            }
        }
        if (formName === 'SurgeryConsent') {
            if (chart && startDate) {
                navigate(`/surgical-consent/${chart}/${formattedDate}/${apptID}`, { state: { openedViaButton: true } });
            } else {
                console.error("Chart or Date is missing");
            }
        }
        else if (formName === 'Demographics') {
            if (chart) {
                navigate(`/existing-patient-registration-form/${chart}/${apptID}`, { state: { openedViaButton: true, show: showForm } });
            } else {
                console.error("Chart is missing");
            }
        }
        else if (formName === 'Patient Registration') {
            if (chart) {
                navigate(`/patient-registration-form/${chart}/${apptID}`, { state: { openedViaButton: true, show: showForm }, replace: true });
            } else {
                console.error("Chart is missing");
            }
        }
    };

    const handlePatientChange = () => {
        const searchTerm = patient.trim().toLowerCase();

        if (tableVisibility === 'table1') {
            const filtered = appointments.filter(
                (item) =>
                    item.patientid.toLowerCase().includes(searchTerm) ||
                    item.name.toLowerCase().includes(searchTerm)
            );
            setFilteredData(filtered);
        } else if (tableVisibility === 'table2' || tableVisibility === 'table3') {
            const filtered = surgeryAppointments.filter((item) => {
                const chart = item.chart?.toLowerCase() || '';
                const firstName = item.first_name?.toLowerCase() || '';
                const lastName = item.last_name?.toLowerCase() || '';

                const fullNameNoSpace = (firstName + lastName).toLowerCase();
                const fullNameWithSpace = `${firstName} ${lastName}`.toLowerCase();

                return (
                    chart.includes(searchTerm) ||
                    firstName.includes(searchTerm) ||
                    lastName.includes(searchTerm) ||
                    fullNameNoSpace.includes(searchTerm) ||
                    fullNameWithSpace.includes(searchTerm)
                );
            });
            setFilteredSurgeryData(filtered);
        }
    };


    useEffect(() => {
        if (patient === "") {
            handleUndo();
        }
    }, [patient]);

    const showSurgeryTaskAlert = ({
        icon,
        title,
        text,
        confirmButtonText = "Close",
        onConfirm = null,
        onClose = () => setTemplate(''),
    }) => {
        Swal.fire({
            icon,
            title,
            text,
            confirmButtonText,
        }).then((result) => {
            if (result.isConfirmed && typeof onConfirm === "function") {
                onConfirm();
            }
            if (typeof onClose === "function") {
                onClose();
            }
        });
    };

    const injectionFormsPopulation = async (chart, apptId) => {

        setIsSubmittingInjectionForm(true);

        try {

            const date = startDate.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            });

            const formattedDate = date.replace(/\//g, '');

            const response = await fetch(
                `${config.API_BASE_URL}/injection/injection_consent_populate`,
                {
                    method: "POST",

                    headers: {
                        "action_id": config.ACTIONID['edit'],
                        "Content-Type": "application/json",
                        Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                        practice: localStorage.getItem(
                            "digital-form-dept-practice"
                        )
                    },

                    body: JSON.stringify({
                        chart: chart,
                        appt_date: formatDateString(formattedDate),
                        practice: localStorage.getItem(
                            "digital-form-dept-practice"
                        ),
                        appt_id: apptId,
                        dept_id: defaultLocation
                    })
                }
            );


            // =====================================================
            // HANDLE ERRORS
            // =====================================================

            if (!response.ok) {

                setOpenInjectionModal(false);

                switch (response.status) {

                    case 401:

                        showSurgeryTaskAlert({
                            icon: "warning",
                            title: "Session Expired",
                            text: "Your session has expired. Please click on 'Restore Session' to create surgical tasks.",
                            confirmButtonText: "Restore Session",
                            onConfirm: () => tryRefresh(false),
                            onClose: null
                        });

                        break;


                    case 403:

                        showSurgeryTaskAlert({
                            icon: "error",
                            title: "Access Denied",
                            text: "You do not have permission to create surgery tasks."
                        });

                        break;


                    case 500:

                        showSurgeryTaskAlert({
                            icon: "error",
                            title: "Server Error",
                            text: "A server error occurred while creating the surgery task. Please try again later."
                        });

                        break;


                    default:

                        showSurgeryTaskAlert({
                            icon: "error",
                            title: "Unexpected Error",
                            text: "Something went wrong while creating the surgery task. Please try again."
                        });
                }

                return;
            }


            // =====================================================
            // SUCCESS
            // =====================================================

            setOpenInjectionModal(false);

            const data = await response.json();

            if (data["taskArn"]) {

                Swal.fire({
                    icon: "success",
                    title: "Injection Task Created",
                    text: "The injection form will be available shortly. Please check back in a few minutes.",
                    confirmButtonText: "Close",
                    timer: 5000,
                    timerProgressBar: true
                });

            } else {

                Swal.fire({
                    icon: "error",
                    title: "Unexpected Error",
                    text: "The request completed but no task was created."
                });
            }


        } catch (error) {

            console.error(
                "Injection form population error:",
                error
            );

            setOpenInjectionModal(false);

            Swal.fire({
                icon: "error",
                title: "Network Error",
                text: "Unable to connect to the server. Please try again."
            });

        } finally {

            // This ALWAYS runs
            setIsSubmittingInjectionForm(false);
        }
    };

    const surgicalFormsPopulation = async (chart, apptId, template, update_center) => {
        setIsSubmittingSurgicalForm(true);
        try {
            const date = startDate.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            });
            const formattedDate = date.replace(/\//g, '');
            let response;
            if (update_center) {
                response = await fetch(`${config.API_BASE_URL}/surgical/update_center`, {
                    method: "POST",
                    headers: {
                        "action_id": config.ACTIONID['edit'], // Assuming the action_id for 'view' is set in config
                        "Content-Type": "application/json",
                        Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                        "practice": localStorage.getItem("digital-form-dept-practice")
                    },
                    body: JSON.stringify(
                        {
                            appt_id: apptId,
                            center: template
                        }
                    ),
                });
            }
            else {
                response = await fetch(`${config.API_BASE_URL}/surgical/surgery_lambda`, {
                    method: "POST",
                    headers: {
                        "action_id": config.ACTIONID['edit'], // Assuming the action_id for 'view' is set in config
                        "Content-Type": "application/json",
                        Authorization: `${localStorage.getItem("digital-form-idtoken")}`,
                        "practice": localStorage.getItem("digital-form-dept-practice")
                    },
                    body: JSON.stringify(
                        {
                            chart: chart,
                            appt_date: formatDateString(formattedDate),
                            practice: `${localStorage.getItem("digital-form-dept-practice")}`,
                            appt_id: apptId,
                            template: template,
                            dept_id: defaultLocation
                        }
                    ),
                });
            }
            if (!response.ok) {
                setOpenSurgicalModal(false);

                // Handle different error scenarios
                switch (response.status) {
                    case 401:
                        showSurgeryTaskAlert({
                            icon: "warning",
                            title: "Session Expired",
                            text: "Your session has expired. Please click on 'Restore Session' to create surgical tasks.",
                            confirmButtonText: "Restore Session",
                            onConfirm: () => tryRefresh(false),
                            onClose: null, // Don't reset template if refreshing
                        });
                        break;

                    case 403:
                        showSurgeryTaskAlert({
                            icon: "error",
                            title: "Access Denied",
                            text: "You do not have permission to create surgery tasks.",
                        });
                        break;

                    case 500:
                        showSurgeryTaskAlert({
                            icon: "error",
                            title: "Server Error",
                            text: "A server error occurred while creating the surgery task. Please try again later.",
                        });
                        break;

                    default:
                        showSurgeryTaskAlert({
                            icon: "error",
                            title: "Unexpected Error",
                            text: "Something went wrong while creating the surgery task. Please try again.",
                        });
                }

                return; // Exit function for error cases
            }
            else if (response.ok) {

                setOpenSurgicalModal(false);
                setTemplate('')
                if (update_center) {
                    Swal.fire({
                        icon: "success",
                        title: "Surgery Center Updated",
                        text: "You can now view the form.",
                        confirmButtonText: "Close",
                        timer: 5000,
                        timerProgressBar: true,
                    }).then(
                        setRefreshKey(prevKey => prevKey + 1)

                    )
                }
                else {
                    const data = await response.json()
                    if (data["taskArn"]) {
                        Swal.fire({
                            icon: "success",
                            title: "Surgery Task Created",
                            text: "The surgical form will be available shortly. Please check back in a few minutes.",
                            confirmButtonText: "Close",
                            timer: 5000,
                            timerProgressBar: true,
                        });

                    }
                }

            }
        } finally {
            setIsSubmittingSurgicalForm(false);
        }
    }

    // Handler for the undo button
    const handleUndo = () => {
        if (tableVisibility === 'table1') {
            // Reset the table data to the original unfiltered state
            setFilteredData(appointments);
            setPatient(''); // Optionally clear the search term
        }
        else if (tableVisibility === 'table2') {
            // Reset the table data to the original unfiltered state
            setFilteredSurgeryData(surgeryAppointments);
            setPatient(''); // Optionally clear the search term
        }

    };

    const StatusBadge = ({ value, label, onClick, isClickable }) => {
        const isNegative = value?.includes('Not');

        return (
            <div
                onClick={onClick}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-full font-medium transition-colors
            ${isNegative
                        ? 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'
                        : 'bg-blue-600 text-white hover:bg-blue-700'
                    }
            ${isClickable ? 'cursor-pointer' : ''}
            `}
            >
                <i
                    className={`fas ${isNegative
                        ? 'fa-exclamation-circle text-blue-600'
                        : 'fa-check-circle text-white'
                        }`}
                />
                <span>{label}</span>
            </div>
        );
    };



    return (
        <div id='daily-appointments' className={`min-h-screen flex flex-col ${isLocked ? 'blur-2xl' : ''}`}>
            {/* Loader Overlay */}
            {isLoading && (
                <div className="loader-overlay flex items-center justify-center fixed top-0 left-0 w-full h-full bg-opacity-50 z-50">
                    <div className="loader"></div> {/* Your loader animation */}
                </div>
            )}
            {isLoading5 && (
                <div className="loader-overlay flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-30 z-50">
                    <div className="loader3 mb-2"></div>
                    <h1 className="text-xl font-medium text-black  mb-3">Loading locations...</h1>
                </div>
            )}


            {isLoading3 && (
                <Refresh />
            )}

            <Header pageTitle={pageTitle} />

            {
                type === 'fdtm' || type === 'exam' || (type === 'surgical' && tableVisibility === 'table1') ? (
                    <>
                        <div className="bg-white px-4 sm:px-6 py-4 border-b border-gray-200">
                            <div className="flex flex-col gap-3 mb-3">
                                <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Search by Chart or Name</p>
                                <div className="flex flex-wrap items-center gap-3">
                                    <input
                                        type="text"
                                        id="patientId"
                                        placeholder="Search"
                                        value={patient}
                                        onChange={(e) => setPatient(e.target.value)}
                                        className="flex-1 min-w-[200px] px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />

                                    <button
                                        id="search"
                                        type="button"
                                        onClick={handlePatientChange}
                                        className="px-5 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center gap-2 transition-colors shadow-md hover:shadow-lg"
                                    >
                                        <i className="fas fa-search"></i> Search
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() => setRefreshKey(prevKey => prevKey + 1)}
                                        className="px-5 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center gap-2 transition-colors shadow-md hover:shadow-lg"
                                    >
                                        <i className="fas fa-sync-alt"></i> Refresh
                                    </button>

                                    {patient && (
                                        <button
                                            type="button"
                                            onClick={handleUndo}
                                            className="px-4 py-2.5 bg-gray-500 text-white text-sm font-medium rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 flex items-center gap-2 transition-colors shadow-md hover:shadow-lg"
                                        >
                                            <i className="fas fa-undo"></i> Undo
                                        </button>
                                    )}

                                    <div className="flex items-center gap-2">
                                        <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide flex items-center gap-1">
                                            <i className="fas fa-calendar text-blue-600"></i>
                                            Date
                                        </p>
                                        <DatePicker
                                            id='startdate'
                                            className="px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent z-[50] min-w-[140px]"
                                            selected={startDate}
                                            dateFormat="MM/dd/yyyy"
                                            onChange={(date) => setStartDate(date)}
                                            withPortal
                                        />
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide flex items-center gap-1">
                                            <i className="fas fa-map-marker-alt text-blue-600"></i>
                                            Location
                                        </p>
                                        <select
                                            id='location'
                                            className="px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[150px]"
                                            value={defaultLocation || ""}
                                            onChange={handleLocation}
                                        >
                                            <option value="" disabled>Select a location</option>
                                            {locations.map((location) => (
                                                <option key={location.dept_id} value={location.dept_id}>
                                                    {location.dept_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide flex items-center gap-1">
                                            <i className="fas fa-user-md text-blue-600"></i>
                                            Physician
                                        </p>
                                        <select
                                            id='physician'
                                            className="px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[120px]"
                                            value={selectedProvider || ""}
                                            onChange={handleProviderChange}
                                        >
                                            <option value="">All</option>
                                            {providers.map((provider) => (
                                                <option key={provider.providerid} value={provider.providerid}>
                                                    {toTitleCase(provider.name)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </>

                ) :
                    <div className={practiceForSurgery === 'rsi' ? 'p-4 grid grid-cols-1 sm:grid-cols-4 gap-3' : 'p-4 grid grid-cols-1 sm:grid-cols-3 gap-3'}>
                        {
                            practiceForSurgery === 'rsi' && (
                                <>
                                    <div className="flex flex-col text-xs md:text-sm">
                                        <label htmlFor='month' className="mb-2 font-semibold text-gray-700 flex items-center gap-1">
                                            <i className="fas fa-calendar text-blue-600"></i>
                                            Month
                                        </label>
                                        <select className="w-full px-3 py-2 border-2 border-gray-300 rounded-md text-xs md:text-sm focus:border-blue-500 focus:outline-none transition-colors hover:border-blue-400"
                                            id="surgicalMonth"
                                            value={selectedMonth}
                                            onChange={(e) => setSelectedMonth(e.target.value)}>
                                            {months.map((month) => (
                                                <option key={month} value={month}>
                                                    {month}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="flex flex-col text-xs md:text-sm">
                                        <label htmlFor='year' className="mb-2 font-semibold text-gray-700 flex items-center gap-1">
                                            <i className="fas fa-clock text-blue-600"></i>
                                            Year
                                        </label>
                                        <DatePicker
                                            selected={new Date(selectedYear, 0)}
                                            onChange={(date) => setSelectedYear(date.getFullYear())}
                                            showYearPicker
                                            dateFormat="yyyy"
                                            className="w-full px-3 py-2 border-2 border-gray-300 rounded-md text-xs md:text-sm focus:border-blue-500 focus:outline-none transition-colors hover:border-blue-400"
                                            popperClassName="z-[9999]"
                                            withPortal
                                        />
                                    </div>

                                    <div className="flex flex-col text-xs md:text-sm">
                                        <label htmlFor='location' className="mb-2 font-semibold text-gray-700 flex items-center gap-1">
                                            <i className="fas fa-hospital-alt text-blue-600"></i>
                                            Surgical Center
                                        </label>
                                        <select id="surgicalLocation"
                                            value={surgicalLocation}
                                            onChange={(e) => setSurgicalLocation(e.target.value)}
                                            className="w-full px-3 py-2 border-2 border-gray-300 rounded-md text-xs md:text-sm focus:border-blue-500 focus:outline-none transition-colors hover:border-blue-400">
                                            <option value="All">All</option>
                                            {surgicalLocations[practiceForSurgery].map((surgicalLocation) => (
                                                <option key={surgicalLocation} value={surgicalLocation}>
                                                    {surgicalLocation}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )
                        }

                        {
                            practiceForSurgery === 'seg' && (
                                <>
                                    <div className="flex flex-col text-xs md:text-sm">
                                        <label htmlFor='dateFrom' className="mb-2 font-semibold text-gray-700 flex items-center gap-1">
                                            <i className="fas fa-calendar text-blue-600"></i>
                                            From Date
                                        </label>
                                        <DatePicker
                                            selected={surgeryDateFrom}
                                            onChange={(date) => setSurgeryDateFrom(date)}
                                            dateFormat="MM/dd/yyyy"
                                            className="w-full px-3 py-2 border-2 border-gray-300 rounded-md text-xs md:text-sm focus:border-blue-500 focus:outline-none transition-colors hover:border-blue-400"
                                            popperClassName="z-[9999]"
                                            withPortal
                                        />
                                    </div>

                                    <div className="flex flex-col text-xs md:text-sm">
                                        <label htmlFor='dateTo' className="mb-2 font-semibold text-gray-700 flex items-center gap-1">
                                            <i className="fas fa-calendar text-blue-600"></i>
                                            To Date
                                        </label>
                                        <DatePicker
                                            selected={surgeryDateTo}
                                            onChange={(date) => setSurgeryDateTo(date)}
                                            dateFormat="MM/dd/yyyy"
                                            className="w-full px-3 py-2 border-2 border-gray-300 rounded-md text-xs md:text-sm focus:border-blue-500 focus:outline-none transition-colors hover:border-blue-400"
                                            popperClassName="z-[9999]"
                                            withPortal
                                        />
                                    </div>
                                </>
                            )
                        }

                        <div className="flex flex-col text-xs md:text-sm">
                            <label htmlFor='physician' className="mb-2 font-semibold text-gray-700 flex items-center gap-1">
                                <i className="fas fa-user-md text-blue-600"></i>
                                Surgeon
                            </label>
                            <select id='surgeon'
                                value={selectedsurgeon}
                                onChange={(e) => setSurgeon(e.target.value)}
                                className="w-full px-3 py-2 border-2 border-gray-300 rounded-md text-xs md:text-sm focus:border-blue-500 focus:outline-none transition-colors hover:border-blue-400">
                                <option value="All">All</option>
                                {surgeons[practiceForSurgery].map((surgeon) => (
                                    <option key={surgeon} value={surgeon}>
                                        {surgeon}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
            }

            {type === "surgical" ? (
                <div className="p-2 grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <button
                        type="button"
                        className="w-full p-1.5 bg-blue-600 text-white rounded-md text-xs md:text-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center justify-center gap-1.5 font-semibold transition-colors shadow-md hover:shadow-lg"
                        onClick={() => setTableVisibility('table1')}
                    >
                        <i className="fas fa-notes-medical text-sm md:text-base"></i>
                        <span>Clinical Appointments</span>
                    </button>

                    {
                        practiceForSurgery === 'seg' && (
                            <button
                                type="button"
                                className="w-full p-1.5 bg-blue-600 text-white rounded-md text-xs md:text-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center justify-center gap-1.5 font-semibold transition-colors shadow-md hover:shadow-lg"
                                onClick={() => setTableVisibility('table3')}
                            >
                                <i className="fas fa-file-medical text-sm md:text-base"></i>
                                <span>Surgical Consents</span>
                            </button>
                        )
                    }

                    {
                        (practiceForSurgery === 'rsi') && (
                            <button
                                type="button"
                                className="w-full p-1.5 bg-blue-600 text-white rounded-md text-xs md:text-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 flex items-center justify-center gap-1.5 font-semibold transition-colors shadow-md hover:shadow-lg"
                                onClick={() => setTableVisibility('table2')}
                            >
                                <i className="fas fa-procedures text-sm md:text-base"></i>
                                <span>Surgical Appointments</span>
                            </button>
                        )
                    }

                </div>
            ) : null}

            {
                (type === 'fdtm') && (
                    <div className="w-full px-4 sm:px-6 py-3">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            {(() => {
                                const indicators = [
                                    {
                                        id: 'nextech',
                                        icon: 'fa-info-circle',
                                        label: 'Nextech Portal',
                                        message: 'Status up to date based on latest automation run completed at 9:30 AM CDT.',
                                        bgColor: 'bg-blue-50',
                                        borderColor: 'border-blue-600',
                                        textColor: 'text-blue-900',
                                        badgeBg: 'bg-blue-600',
                                        show: true
                                    },
                                    {
                                        id: 'optos',
                                        icon: 'fa-eye',
                                        label: 'Optos Consent',
                                        message: 'Indicates patients who need Optos consent (verbally or digitally).',
                                        bgColor: 'bg-orange-50',
                                        borderColor: 'border-orange-600',
                                        textColor: 'text-orange-900',
                                        badgeBg: 'bg-orange-600',
                                        show: practiceForSurgery === 'seg'
                                    }
                                ];

                                return indicators
                                    .filter(indicator => indicator.show)
                                    .map((indicator) => (
                                        <div
                                            key={indicator.id}
                                            className={`flex items-center gap-3 ${indicator.bgColor} border-l-4 ${indicator.borderColor} ${indicator.textColor} rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5`}
                                        >
                                            {/* Futuristic Icon Badge */}
                                            <div className="flex-shrink-0">
                                                <div className={`flex items-center justify-center h-10 w-10 rounded-lg ${indicator.badgeBg} shadow-lg`}>
                                                    <i className={`fas ${indicator.icon} text-white text-sm`}></i>
                                                </div>
                                            </div>

                                            {/* Content */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm font-semibold">
                                                    {indicator.label}
                                                </p>
                                                <p className="text-xs opacity-90 mt-0.5 truncate">
                                                    {indicator.message}
                                                </p>
                                            </div>
                                        </div>
                                    ));
                            })()}
                        </div>
                    </div>
                )
            }
            {
                tableVisibility === 'table1' ?
                    (

                        <div className="relative overflow-auto max-h-[70vh] modern-scroll bg-white rounded-xl shadow-lg border border-gray-200 my-3 mx-2">

                            <table className="min-w-full divide-y divide-gray-200 table-fixed border-separate" style={{ borderSpacing: '0 12px' }}>
                                <thead className="sticky top-0 z-30 bg-blue-600 text-center">
                                    <tr>
                                        {[
                                            { key: 'patientid', label: 'Chart #' },
                                            { key: 'name', label: 'Name & DOB' },
                                            { key: 'appt_type', label: 'Appt Type and Physician' },
                                            { key: 'appt_date_time', label: 'Date & Time' }
                                        ].map(({ key, label }, index) => (
                                            <th
                                                key={key}
                                                onClick={() => !isLocked && handleSort(key, setSortConfig, sortConfig)}
                                                className={`px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide cursor-pointer hover:bg-blue-700 transition-colors
                                                 sticky top-0 z-10 bg-blue-600`}
                                            >
                                                {label}{' '}
                                                {sortConfig.key === key && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>

                                        ))}

                                        <th className="px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide sticky top-0 bg-blue-600 z-10">
                                            Actions
                                        </th>

                                        {
                                            type === 'exam' &&
                                            (
                                                <>
                                                    <th className="px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide sticky top-0 bg-blue-600 z-10">
                                                        Coverage Verification
                                                    </th>
                                                    <th className="px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide sticky top-0 bg-blue-600 z-10">
                                                        Digital Status
                                                    </th>
                                                </>
                                            )
                                        }



                                        {type === 'fdtm' && (
                                            <>
                                                <th className="px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide sticky top-0 bg-blue-600 z-10">
                                                    Notifications
                                                </th>
                                                <th className="px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide sticky top-0 bg-blue-600 z-10">
                                                    Digital Status
                                                </th>
                                                <th className="px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide sticky top-0 bg-blue-600 z-10">
                                                    CHC Status
                                                </th>
                                                <th className="px-4 py-3 text-center text-sm font-semibold text-white uppercase tracking-wide sticky top-0 bg-blue-600 z-10">
                                                    Nextech Portal
                                                </th>

                                            </>
                                        )}
                                    </tr>
                                </thead>

                                <tbody className="bg-transparent text-center space-y-3">
                                    {sortedData.length > 0 ? (
                                        sortedData.map((item, idx) => (
                                            <tr
                                                key={item.appt_id}
                                                className="bg-white border-2 border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 shadow-md hover:shadow-lg m-2"
                                            >
                                                <td className="sticky left-0 z-10 bg-white px-4 py-4">
                                                    <div className="flex flex-col items-center gap-2.5">
                                                        <span className="font-semibold text-sm text-gray-900">{item.patientid}</span>

                                                        <button
                                                            onClick={() => setOpenPhotoChart(item.patientid)}
                                                            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-white text-blue-500 text-xs transition-all duration-200 cursor-pointer hover:bg-blue-50"
                                                        >
                                                            <i className="fas fa-camera-alt"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className="px-4 py-3 text-sm text-gray-900">
                                                    <div className="flex flex-col items-center gap-2.5">
                                                        <div className="flex items-center gap-2.5">
                                                            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-blue-600">
                                                                <i className="fas fa-user text-xs"></i>
                                                            </div>
                                                            <span className="font-semibold text-gray-900">{item.name}</span>
                                                        </div>
                                                        <div className="flex items-center gap-2 text-gray-500">
                                                            <i className="fas fa-calendar-alt text-xs text-gray-400"></i>
                                                            <span className="text-xs">{item.dob}</span>
                                                        </div>
                                                        <div
                                                            className={`inline-flex items-center gap-2 rounded-md border px-2 py-1 ${item.contact_details?.includes("Missing")
                                                                ? "bg-red-50 text-red-700 border-red-200"
                                                                : "bg-green-50 text-green-700 border-green-200"
                                                                }`}
                                                        >
                                                            <i
                                                                className={`fas ${item.contact_details?.includes("Missing")
                                                                    ? "fa-exclamation-circle"
                                                                    : "fa-check-circle"
                                                                    } text-xs`}
                                                            ></i>
                                                            <span className="text-xs font-medium">
                                                                {item.contact_details}
                                                            </span>
                                                        </div>
                                                    </div>

                                                </td>
                                                <td className="px-4 py-3 text-sm text-gray-900">
                                                    <div className="flex flex-col items-center gap-2.5">
                                                        <div className="flex items-center gap-2.5">
                                                            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 text-blue-600">
                                                                <i className="fas fa-notes-medical text-xs"></i>
                                                            </div>
                                                            <span className="font-semibold text-gray-900">
                                                                {item.appt_type}
                                                            </span>
                                                        </div>
                                                        <div className="flex items-center gap-2 text-gray-500">
                                                            <i className="fas fa-stethoscope text-xs text-gray-400"></i>
                                                            <span className="text-xs">

                                                                {item.physician_name}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-4 py-3 text-sm text-gray-900">
                                                    <div className="flex items-center gap-2 justify-center">
                                                        <i className="fas fa-calendar-check text-blue-500"></i>
                                                        <span>{item.appt_date_time}</span>
                                                    </div>
                                                </td>

                                                <td className="px-4 py-3 text-center">
                                                    {isLoading1 ? (

                                                        <div className="flex justify-center items-center">
                                                            <div className="loader4"></div>
                                                        </div>
                                                    ) : (
                                                        <div className="flex flex-col justify-center gap-2 items-center">

                                                            {/* Registration / Demographics Button */}
                                                            {type === 'fdtm' && (

                                                                <button
                                                                    onClick={() => {
                                                                        !isLocked &&
                                                                            (handleExpandClick(
                                                                                item.patient_registration.includes('New Patient')
                                                                                    ? config.formTypes[0]
                                                                                    : config.formTypes[1],
                                                                                item.patientid,
                                                                                item.appt_id,
                                                                                item.provider_type
                                                                            ))
                                                                    }
                                                                    }
                                                                    className={`inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-md font-medium text-xs md:text-sm transition-all duration-200 cursor-pointer shadow-md hover:shadow-lg w-30
                                                                           ${item.patient_registration.includes('Not Filled')
                                                                            ? 'bg-red-500 text-white hover:bg-red-600'
                                                                            : 'bg-green-500 text-white hover:bg-green-600'
                                                                        }
                                                                            `}
                                                                >
                                                                    <i className="fas fa-user-edit text-xs md:text-sm"></i>
                                                                    <span className="text-xs md:text-sm">
                                                                        {item.patient_registration.includes('New')
                                                                            ? 'Registration'
                                                                            : 'Demographics'}
                                                                    </span>
                                                                </button>

                                                            )}

                                                            {/* Check-in / Clinic Arrival Button */}
                                                            {type === 'fdtm' && (
                                                                <>
                                                                    <button
                                                                        onClick={() =>
                                                                            !isLocked &&
                                                                            item.checkin !== 'checkedin' &&
                                                                            window.open(`${config.ATHENA_PRAC_ID}?ID=${item.appt_id}`, '_blank')
                                                                        }
                                                                        className={`inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-md transition-all duration-200 cursor-pointer shadow-md hover:shadow-lg w-28
                                                                ${item.checkin === 'checkedin'
                                                                                ? 'bg-green-600 text-white hover:bg-green-700'
                                                                                : 'bg-red-600 text-white hover:bg-red-700'
                                                                            }
                                                                        `}
                                                                    >
                                                                        <i className="fas fa-building text-xs md:text-sm"></i>
                                                                        <span className="text-xs md:text-sm">
                                                                            Check In
                                                                        </span>
                                                                    </button>
                                                                    <button
                                                                        onClick={() =>
                                                                            !isLocked &&
                                                                            item.checkout !== 'checkedout' &&
                                                                            window.open(`${config.ATHENA_PRAC_ID}?ID=${item.appt_id}`, '_blank')
                                                                        }
                                                                        className={`inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-md transition-all duration-200 cursor-pointer shadow-md hover:shadow-lg w-28
                                                                ${item.checkout === 'checkedout'
                                                                                ? 'bg-green-600 text-white hover:bg-green-700'
                                                                                : 'bg-red-600 text-white hover:bg-red-700'
                                                                            }
                                                                        `}
                                                                    >
                                                                        <i className="fas fa-building text-xs md:text-sm"></i>
                                                                        <span className="text-xs md:text-sm">
                                                                            Check Out
                                                                        </span>
                                                                    </button>
                                                                </>
                                                            )}


                                                            {/* Surgical Form Button */}
                                                            {type === 'surgical' && (
                                                                <button
                                                                    onClick={() =>
                                                                        !isLocked &&
                                                                        ((item.surgery_forms === 'Not Fetched' || !item.surgery_forms)
                                                                            ? openModalWithData(item.patientid, item.appt_id)
                                                                            : item.surgery_forms === 'Not Uploaded' &&
                                                                            handleExpandClick(localStorage.getItem('practice') === 'rsi' ? config.formTypes[2] : config.formTypes[3], item.patientid, item.appt_id, null))
                                                                    }
                                                                    className={`inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-md transition-all duration-200 cursor-pointer shadow-md hover:shadow-lg w-28
                                                                     ${!item.surgery_forms || item.surgery_forms === 'Not Fetched'
                                                                            ? 'bg-red-600 text-white hover:bg-red-700'
                                                                            : item.surgery_forms === 'Not Uploaded'
                                                                                ? 'bg-violet-600 text-white hover:bg-violet-700'
                                                                                : 'bg-green-600 text-white opacity-60 cursor-not-allowed'
                                                                        }
                                                                        `}
                                                                >
                                                                    <i className="fas fa-file-medical text-xs md:text-sm"></i>
                                                                    <span className="text-xs md:text-sm">Surgery Form</span>
                                                                </button>
                                                            )}

                                                            {/* EXAM ROOM Form Button */}
                                                            {(type === 'exam' && localStorage.getItem('digital-form-dept-practice') === 'rsi') && (
                                                                <>
                                                                    <div className="inline-flex items-center gap-1">

                                                                        {/* Main Injection Consent Button */}
                                                                        <button
                                                                            onClick={() => {
                                                                                if (isLocked) return;
                                                                                handleExpandClick(
                                                                                    config.formTypes[4],
                                                                                    item.patientid,
                                                                                    item.appt_id,
                                                                                    null,
                                                                                    item.injection_consent === 'Not Fetched' ? false : true
                                                                                );
                                                                            }}
                                                                            className={`inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-md transition-all duration-200 shadow-md hover:shadow-lg w-40
                                                                                     ${!item.injection_consent ||
                                                                                    item.injection_consent === 'Not Fetched'
                                                                                    ? 'bg-red-600 text-white hover:bg-red-700 cursor-pointer'
                                                                                    : (item.injection_consent === 'Not Uploaded' || item.injection_consent === 'Review Needed')
                                                                                        ? 'bg-violet-600 text-white hover:bg-violet-700 cursor-pointer'
                                                                                        : 'bg-green-600 text-white opacity-60 cursor-not-allowed'
                                                                                }
    `}                                                                    >
                                                                            <i className="fas fa-file-medical text-xs md:text-sm"></i>

                                                                            <span className="text-xs md:text-sm">
                                                                                Injection Consent
                                                                            </span>
                                                                        </button>


                                                                        {/* Regenerate Button */}
                                                                        <button
                                                                            type="button"
                                                                            title="Regenerate"
                                                                            disabled={isLocked}
                                                                            onClick={() => {
                                                                                openModalWithData(
                                                                                    item.patientid,
                                                                                    item.appt_id,
                                                                                    false,
                                                                                    true
                                                                                );
                                                                            }}
                                                                            className="inline-flex items-center justify-center px-2 py-1.5 rounded-md bg-red-600 text-white hover:bg-red-700 shadow-md"
                                                                        >
                                                                            <i className="fas fa-rotate-right text-xs md:text-sm"></i>
                                                                        </button>
                                                                    </div>

                                                                    <div className="inline-flex items-center gap-1">
                                                                        <StatusBadge
                                                                            value={item.pcm}
                                                                            label={`PCM ${item.pcm?.includes('Not') ? 'Not Consented' : 'Consented'}`}
                                                                            onClick={() => {
                                                                                if (item.pcm?.includes('Not')) {
                                                                                    handlePCMClick(item);
                                                                                }
                                                                            }}
                                                                            isClickable={true}
                                                                        />
                                                                    </div>
                                                                </>

                                                            )}
                                                        </div>
                                                    )}
                                                </td>


                                                {type === 'exam' && (
                                                    <>
                                                        {
                                                            localStorage.getItem("digital-form-dept-practice") === 'rsi' && (
                                                                <>
                                                                    <td className="px-2 py-1.5 text-center">
                                                                        {/* Flagging Coverage Button */}
                                                                        <button
                                                                            onClick={() => {
                                                                                setCoverageModalData(item.flagging);
                                                                                setCoverageModalOpen(true);
                                                                            }}
                                                                            className={`inline-flex items-center justify-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer
                                                                                ${item.flagging && item.flagging.includes('NOT_COVERED')
                                                                                    ? 'bg-red-600 text-white hover:bg-red-700'
                                                                                    : item.flagging && item.flagging.includes('COVERED')
                                                                                        ? 'bg-green-600 text-white hover:bg-green-700'
                                                                                        : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                                                                                }`}
                                                                            title="Click to view coverage details"
                                                                        >
                                                                            <i className={`fas text-xs
                                                                                ${item.flagging && item.flagging.includes('NOT_COVERED')
                                                                                    ? 'fa-times-circle'
                                                                                    : item.flagging && item.flagging.includes('COVERED')
                                                                                        ? 'fa-check-circle'
                                                                                        : 'fa-minus-circle'
                                                                                }`}
                                                                            />
                                                                            <span>
                                                                                {item.flagging && item.flagging.includes('NOT_COVERED')
                                                                                    ? 'Not Covered'
                                                                                    : item.flagging && item.flagging.includes('COVERED')
                                                                                        ? 'Covered'
                                                                                        : 'No Data'}
                                                                            </span>
                                                                        </button>
                                                                    </td>
                                                                    <td className="px-2 py-1.5 text-center">
                                                                        {/* Intake Forms Badge */}
                                                                        <div
                                                                            onClick={() =>
                                                                                !isLocked &&
                                                                                (item.injection_consent === 'Not Uploaded' ||
                                                                                    item.injection_consent === 'Uploaded' ||
                                                                                    item.injection_consent === 'Review Needed') &&
                                                                                ModalForFiles(
                                                                                    item.appt_id,
                                                                                    item.injection_consent === 'Review Needed' ? true : false,
                                                                                    config.formTypes[4]
                                                                                )
                                                                            }
                                                                            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-colors
                                                                        ${item.injection_consent === 'Uploaded'
                                                                                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                                                                                    : item.injection_consent === 'Not Uploaded'
                                                                                        ? 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'
                                                                                        : item.injection_consent === 'Review Needed'
                                                                                            ? 'bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100'
                                                                                            : 'bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100'
                                                                                }`}
                                                                        >
                                                                            <i
                                                                                className={`fas text-xs
                                                                        ${item.injection_consent === 'Uploaded'
                                                                                        ? 'fa-check-circle text-white'
                                                                                        : item.injection_consent === 'Not Uploaded'
                                                                                            ? 'fa-upload text-blue-600'
                                                                                            : item.injection_consent === 'Review Needed'
                                                                                                ? 'fa-search text-amber-600'
                                                                                                : 'fa-exclamation-circle text-gray-500'
                                                                                    }`}
                                                                            />
                                                                            <span>
                                                                                {item.injection_consent === 'Uploaded'
                                                                                    ? 'Uploaded'
                                                                                    : item.injection_consent === 'Not Uploaded'
                                                                                        ? 'Not Uploaded'
                                                                                        : item.injection_consent === 'Review Needed'
                                                                                            ? 'Review'
                                                                                            : 'No Form Activity'}
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                )}

                                                {type === 'fdtm' && (
                                                    <>
                                                        {
                                                            localStorage.getItem("digital-form-dept-practice") === 'seg' && (
                                                                <td className="px-2 py-1.5 text-center">
                                                                    <div className="flex flex-col items-center justify-center gap-2">
                                                                        {item.optos_consent_required && (
                                                                            <div className="flex items-center justify-center h-7 w-7 rounded-lg bg-orange-600 shadow-md hover:shadow-lg transition-all" title="Optos Consent Required">
                                                                                <i className="fas fa-eye text-white text-xs"></i>
                                                                            </div>
                                                                        )}
                                                                        <StatusBadge value={item.optos} label={`Optos ${item.optos?.includes('Not') ? 'Not Interested' : 'Interested'}`} />
                                                                        <StatusBadge value={item.abn} label={`ABN ${item.abn?.includes('Not') ? 'Not Interested' : 'Interested'}`} />
                                                                    </div>
                                                                </td>
                                                            )
                                                        }

                                                        {
                                                            localStorage.getItem("digital-form-dept-practice") === 'rsi' && (
                                                                <td className="px-2 py-1.5 text-center">
                                                                    <div className="flex flex-col items-center justify-center gap-2">
                                                                        <StatusBadge
                                                                            value={item.pcm}
                                                                            label={`PCM ${item.pcm?.includes('Not') ? 'Not Consented' : 'Consented'}`}
                                                                            onClick={() => {
                                                                                if (item.pcm?.includes('Not')) {
                                                                                    handlePCMClick(item);
                                                                                }
                                                                            }}
                                                                            isClickable={true}
                                                                        />
                                                                    </div>
                                                                </td>
                                                            )
                                                        }

                                                        <td className="px-2 py-1.5 text-center">
                                                            <div className="flex flex-col items-center gap-2">
                                                                {/* Form Status Badge */}
                                                                <div
                                                                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium
                                                                     ${item.form_status?.includes('Demo')
                                                                            ? 'bg-blue-600 text-white'
                                                                            : item.form_status?.includes('Reg')
                                                                                ? 'bg-blue-600 text-white'
                                                                                : item.form_status?.includes('Not')
                                                                                    ? 'bg-blue-50 text-blue-700 border border-blue-200'
                                                                                    : 'bg-gray-50 text-gray-600 border border-gray-200'
                                                                        }`}
                                                                >
                                                                    <i
                                                                        className={`fas text-xs
                                                                     ${item.form_status?.includes('Demo')
                                                                                ? 'fa-check-circle text-white'
                                                                                : item.form_status?.includes('Reg')
                                                                                    ? 'fa-check-circle text-white'
                                                                                    : item.form_status?.includes('Not')
                                                                                        ? 'fa-exclamation-circle text-blue-600'
                                                                                        : 'fa-question-circle text-gray-500'
                                                                            }`}
                                                                    />
                                                                    <span>
                                                                        {item.form_status?.includes('Demo')
                                                                            ? 'Previously Submitted: Demographics'
                                                                            : item.form_status?.includes('Reg')
                                                                                ? 'Previously Submitted: Registration'
                                                                                : 'No Previous Digital Submission'}
                                                                    </span>
                                                                </div>


                                                                {/* Intake Forms Badge */}
                                                                <div
                                                                    onClick={() =>
                                                                        !isLocked &&
                                                                        (item.intake_forms === 'Not Uploaded' ||
                                                                            item.intake_forms === 'Uploaded' ||
                                                                            item.intake_forms === 'Review Needed') &&
                                                                        ModalForFiles(
                                                                            item.appt_id,
                                                                            item.intake_forms === 'Review Needed' ? true : false,
                                                                            item.patient_registration.includes('New')
                                                                                ? 'registration'
                                                                                : 'demographics'
                                                                        )
                                                                    }
                                                                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-colors
                                                                    ${item.intake_forms === 'Uploaded'
                                                                            ? 'bg-blue-600 text-white hover:bg-blue-700'
                                                                            : item.intake_forms === 'Not Uploaded'
                                                                                ? 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'
                                                                                : item.intake_forms === 'Review Needed'
                                                                                    ? 'bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100'
                                                                                    : 'bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100'
                                                                        }`}
                                                                >
                                                                    <i
                                                                        className={`fas text-xs
                                                                    ${item.intake_forms === 'Uploaded'
                                                                                ? 'fa-check-circle text-white'
                                                                                : item.intake_forms === 'Not Uploaded'
                                                                                    ? 'fa-upload text-blue-600'
                                                                                    : item.intake_forms === 'Review Needed'
                                                                                        ? 'fa-search text-amber-600'
                                                                                        : 'fa-exclamation-circle text-gray-500'
                                                                            }`}
                                                                    />
                                                                    <span>
                                                                        {item.intake_forms === 'Uploaded'
                                                                            ? 'Uploaded'
                                                                            : item.intake_forms === 'Not Uploaded'
                                                                                ? 'Not Uploaded'
                                                                                : item.intake_forms === 'Review Needed'
                                                                                    ? 'Review'
                                                                                    : 'No Form Activity'}
                                                                    </span>
                                                                </div>

                                                            </div>
                                                        </td>



                                                        <td className="px-2 py-1.5 text-center">
                                                            {item.app_status === 'Installed' ? (
                                                                <div
                                                                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-xs rounded-full font-medium cursor-pointer hover:bg-blue-700 transition-colors"
                                                                    onClick={() =>
                                                                        !isLocked &&
                                                                        setOpenNotificationBox({
                                                                            ...item,
                                                                            chartNumber: item.patientid,
                                                                            name: item.first_name
                                                                        })
                                                                    }
                                                                >
                                                                    <i className="fas fa-check-circle text-white"></i>
                                                                    <span>Installed</span>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div
                                                                        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 text-xs rounded-full font-medium cursor-pointer hover:bg-blue-100 transition-colors"
                                                                        onClick={() =>
                                                                            !isLocked && sendInviteHandler(item.patientid)
                                                                        }
                                                                    >
                                                                        <i className="fas fa-mobile-alt text-blue-600"></i>
                                                                        <span>Not Installed</span>
                                                                    </div>

                                                                    <p className="text-xs text-gray-500 mt-0.5">
                                                                        {item.invite_sent}
                                                                    </p>
                                                                </>
                                                            )}
                                                        </td>


                                                        <td className="px-2 py-1.5 text-center">
                                                            {item.portal_status === 'Portal Registered' ? (
                                                                <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 text-white text-xs rounded-full font-medium">
                                                                    <i className="fas fa-check-circle text-white"></i>
                                                                    <span>{item.portal_status}</span>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <div
                                                                        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-amber-50 text-amber-700 border border-amber-200 text-xs rounded-full font-medium cursor-pointer hover:bg-amber-100 transition-colors"
                                                                        onClick={() =>
                                                                            !isLocked && sendPortalInviteHandler(item.patientid, item.appt_id)
                                                                        }
                                                                    >
                                                                        <i className="fas fa-exclamation-circle text-amber-600"></i>
                                                                        <span>{item.portal_status}</span>
                                                                    </div>

                                                                    <p className="text-xs text-gray-500 mt-0.5">
                                                                        {item.portal_invite}
                                                                    </p>
                                                                </>
                                                            )}
                                                        </td>

                                                    </>
                                                )}

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={type === 'fdtm' ? 9 : 7}
                                                className="px-6 py-12 text-center"
                                            >
                                                <div className="flex flex-col items-center">
                                                    <i className="fas fa-calendar-times text-4xl text-gray-300 mb-3"></i>
                                                    <p className="text-gray-500 font-medium">No appointments found</p>
                                                    <p className="text-gray-400 text-sm mt-1">
                                                        Try selecting a different date or location or provider
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )
                    : tableVisibility === 'table2' ? (
                        <div className="relative overflow-auto max-h-[70vh] modern-scroll bg-white rounded-xl shadow-lg border border-gray-200 my-3 mx-2">
                            <table className="min-w-full divide-y divide-gray-200 table-fixed border-separate" style={{ borderSpacing: '0 12px' }}>
                                <thead className="sticky top-0 z-30 bg-gradient-to-r from-blue-600 to-blue-700 text-center">
                                    <tr>
                                        {[
                                            { key: 'chart', label: 'Chart' },
                                            { key: 'first_name', label: 'Name' },
                                            { key: 'template', label: 'Surgical Center' },
                                            { key: 'surgeon', label: 'Surgeon' }
                                        ].map(({ key, label }, index) => (
                                            <th
                                                key={key}
                                                onClick={() => !isLocked && handleSort(key, setSortConfig, sortConfig)}
                                                className={`px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider cursor-pointer hover:bg-blue-700 transition-colors text-center ${index === 0
                                                    ? 'sticky left-0 top-0 bg-blue-600 z-20' // First column sticky
                                                    : 'sticky top-0 bg-blue-600 z-10'       // Other headers sticky
                                                    }`}
                                            >
                                                {label}{' '}
                                                {sortConfig.key === key &&
                                                    (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                            </th>
                                        ))}
                                        <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                            Action
                                        </th>
                                        <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                            Form Status
                                        </th>
                                        <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                            Consent
                                        </th>
                                        <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                            History
                                        </th>
                                        <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                            Edit
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className="bg-transparent text-center space-y-3">
                                    {sortedSurgeryData.length > 0 ? (
                                        sortedSurgeryData.map((item, index) => (
                                            <tr key={index} className="bg-white border-2 border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-400 transition-all duration-200 shadow-md hover:shadow-lg m-2">
                                                <td className="sticky left-0 z-10 bg-white px-2 py-1.5 text-xs md:text-sm text-gray-900 text-center">{item.chart}</td>
                                                <td className="px-2 py-1.5 text-xs md:text-sm text-gray-900 text-center">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                                                            <i className="fas fa-user text-xs"></i>
                                                        </div>
                                                        <span>{`${item.first_name} ${item.last_name}`}</span>
                                                    </div>
                                                </td>
                                                <td className="px-2 py-1.5 text-xs md:text-sm text-gray-900 text-center">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                                                            <i className="fas fa-hospital-alt text-xs"></i>
                                                        </div>
                                                        <span>{item.template}</span>
                                                    </div>
                                                </td>
                                                <td className="px-2 py-1.5 text-xs md:text-sm text-gray-900 text-center">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                                                            <i className="fas fa-user-md text-xs"></i>
                                                        </div>
                                                        <span>{item.surgeon}</span>
                                                    </div>
                                                </td>
                                                <td className="px-2 py-1.5 text-center">
                                                    <button
                                                        onClick={() =>
                                                            !isLocked &&
                                                            handleExpandClick(config.formTypes[2], item.chart, item.appt_id, null)
                                                        }
                                                        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors
                                                        ${isLocked ? 'bg-gray-100 text-gray-950 cursor-not-allowed' : 'bg-blue-100 text-blue-950 hover:bg-blue-200'}`}
                                                    >
                                                        <i className="fas fa-file-medical text-blue-600"></i>
                                                        <span>View Form</span>
                                                    </button>
                                                </td>

                                                <td className="px-2 py-1.5 text-center">
                                                    <button
                                                        onClick={() =>
                                                            !isLocked &&
                                                            (item.uploaded_to_nextech === false || item.uploaded_to_nextech === true) &&
                                                            ModalForSurgery(item.s3_path)
                                                        }
                                                        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium cursor-pointer transition-colors
                                                            ${item.uploaded_to_nextech === true
                                                                ? 'bg-blue-600 text-white hover:bg-blue-700'
                                                                : item.uploaded_to_nextech === false
                                                                    ? 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'
                                                                    : 'bg-slate-50 text-slate-600 border border-slate-200 hover:bg-slate-100'
                                                            }`}
                                                        title={
                                                            item.uploaded_to_nextech === true
                                                                ? 'Uploaded'
                                                                : item.uploaded_to_nextech === false
                                                                    ? 'Not Uploaded'
                                                                    : 'Not Reviewed'
                                                        }
                                                    >
                                                        <i
                                                            className={`fas text-xs ${item.uploaded_to_nextech === true
                                                                ? 'fa-check-circle text-white'
                                                                : item.uploaded_to_nextech === false
                                                                    ? 'fa-times-circle text-blue-600'
                                                                    : 'fa-exclamation-circle text-slate-500'
                                                                }`}
                                                        ></i>

                                                        <span className="hidden md:inline">
                                                            {item.uploaded_to_nextech === true
                                                                ? 'Uploaded'
                                                                : item.uploaded_to_nextech === false
                                                                    ? 'Not Uploaded'
                                                                    : 'Not Reviewed'}
                                                        </span>
                                                    </button>

                                                </td>

                                                <td className="px-2 py-1.5 text-center">
                                                    <span onClick={() => !isLocked && item.consent_sent !== true && consentEmail(item.first_name + ' ' + item.last_name, item.chart, item.appt_id, item.s3_path, item.template)} className={` inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-full flex-shrink-0 transition-colors cursor-pointer ${item.consent_sent === true ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'} `} title={item.consent_sent === true ? 'Consent Sent' : 'Send Consent'} > <i className={`fas ${item.consent_sent === true ? 'fa-check-circle text-white' : 'fa-paper-plane text-blue-600'} text-xs md:text-sm`} ></i> </span>
                                                </td>

                                                <td className="px-2 py-1.5">
                                                    <button
                                                        onClick={() =>
                                                            !isLocked &&
                                                            handleHistory(item.edited_by, item.created_at, item.created_by)
                                                        }
                                                        disabled={isLocked}
                                                        className={`
                                                         w-6 h-6 md:w-8 md:h-8 inline-flex items-center justify-center rounded-full
                                                        bg-blue-100 text-blue-800
                                                        transition-colors duration-200
                                                        hover:bg-blue-700
                                                        `}
                                                        title="History"
                                                    >
                                                        <i className="fas fa-history text-xs md:text-sm"></i>
                                                    </button>

                                                </td>
                                                <td className="px-2 py-1.5">
                                                    <button
                                                        onClick={() =>
                                                            !isLocked && openModalWithData(item.chart, item.appt_id, true)
                                                        }
                                                        disabled={isLocked}
                                                        className={`
                                                         w-6 h-6 md:w-8 md:h-8 inline-flex items-center justify-center rounded-full
                                                        bg-blue-100 text-blue-800
                                                        transition-colors duration-200
                                                        hover:bg-blue-700
                                                        `}
                                                        title="Edit Chart"
                                                    >
                                                        <i className="fas fa-edit text-xs md:text-sm"></i>
                                                    </button>
                                                </td>


                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={9} className="px-6 py-12 text-center">
                                                <div className="flex flex-col items-center">
                                                    <i className="fas fa-inbox text-4xl text-gray-300 mb-3"></i>
                                                    <p className="text-gray-500 font-medium">
                                                        No surgical appointments found
                                                    </p>
                                                    <p className="text-gray-400 text-sm mt-1">
                                                        Try adjusting your filters
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )
                        :
                        tableVisibility === 'table3' ? (
                            <div className="relative overflow-auto max-h-[70vh] modern-scroll bg-white rounded-xl shadow-lg border border-gray-200 my-3 mx-2">
                                <table className="min-w-full divide-y divide-gray-200 table-fixed border-separate" style={{ borderSpacing: '0 12px' }}>
                                    <thead className="sticky top-0 z-30 bg-gradient-to-r from-blue-600 to-blue-700 text-center">
                                        <tr>
                                            {[
                                                { key: 'chart', label: 'Chart' },
                                                { key: 'first_name', label: 'Name' },
                                                { key: 'surgeon', label: 'Surgeon' }
                                            ].map(({ key, label }, index) => (
                                                <th
                                                    key={key}
                                                    onClick={() => !isLocked && handleSort(key, setSortConfig, sortConfig)}
                                                    className={`px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider cursor-pointer hover:bg-blue-700 transition-colors text-center ${index === 0
                                                        ? 'sticky left-0 top-0 bg-blue-600 z-20' // First column sticky
                                                        : 'sticky top-0 bg-blue-600 z-10'       // Other headers sticky
                                                        }`}
                                                >
                                                    {label}{' '}
                                                    {sortConfig.key === key &&
                                                        (sortConfig.direction === 'asc' ? '↑' : '↓')}
                                                </th>
                                            ))}
                                            <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                                Action
                                            </th>
                                            <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                                Form Status
                                            </th>
                                            <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                                Consent
                                            </th>
                                            <th className="px-2 py-2 text-xs font-semibold text-white uppercase tracking-wider text-center sticky top-0 bg-blue-600 z-10">
                                                History
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-transparent text-center space-y-3">
                                        {sortedSurgeryData.length > 0 ? (
                                            sortedSurgeryData.map((item, index) => (
                                                <tr key={index} className="bg-white border-2 border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-400 transition-all duration-200 shadow-md hover:shadow-lg m-2">
                                                    <td className="sticky left-0 z-10 bg-white px-2 py-1.5 text-xs md:text-sm text-gray-900 text-center">{item.chart}</td>
                                                    <td className="px-2 py-1.5 text-xs md:text-sm text-gray-900 text-center">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                                                                <i className="fas fa-user text-xs"></i>
                                                            </div>
                                                            <span>{`${item.first_name} ${item.last_name}`}</span>
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-1.5 text-xs md:text-sm text-gray-900 text-center">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-blue-600">
                                                                <i className="fas fa-user-md text-xs"></i>
                                                            </div>
                                                            <span>{item.surgeon}</span>
                                                        </div>
                                                    </td>
                                                    <td className="px-2 py-1.5 text-center">
                                                        <div
                                                            onClick={() =>
                                                                !isLocked &&
                                                                handleExpandClick(config.formTypes[3], item.chart, item.appt_id, null)
                                                            }
                                                            className={`
                                                        inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-medium text-xs
                                                        bg-blue-100 text-blue-950
                                                        cursor-pointer transition-colors
                                                        hover:bg-blue-200
                                                        ${isLocked ? 'opacity-50 cursor-not-allowed' : ''}
                                                        `}
                                                        >
                                                            <i className="fas fa-file-medical text-blue-600"></i>
                                                            <span>View Form</span>
                                                        </div>
                                                    </td>

                                                    <td className="px-2 py-1.5 text-center">
                                                        <button
                                                            onClick={() =>
                                                                !isLocked &&
                                                                (item.uploaded_to_nextech === false ||
                                                                    item.uploaded_to_nextech === true) &&
                                                                ModalForSurgery(item.s3_path)
                                                            }
                                                            className={`
                                                            inline-flex items-center justify-center gap-1 px-3 py-1.5 rounded-full text-xs font-medium
                                                            flex-shrink-0 transition-colors cursor-pointer
                                                            ${item.uploaded_to_nextech === true
                                                                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                                                                    : item.uploaded_to_nextech === false
                                                                        ? 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'
                                                                        : 'bg-slate-50 text-slate-600 border border-slate-200 hover:bg-slate-100'
                                                                }
                                                                        `}
                                                            title={
                                                                item.uploaded_to_nextech === true
                                                                    ? 'Uploaded'
                                                                    : item.uploaded_to_nextech === false
                                                                        ? 'Not Uploaded'
                                                                        : 'Not Reviewed'
                                                            }
                                                        >
                                                            <i
                                                                className={`fas text-xs ${item.uploaded_to_nextech === true
                                                                    ? 'fa-check-circle text-white'
                                                                    : item.uploaded_to_nextech === false
                                                                        ? 'fa-times-circle text-blue-600'
                                                                        : 'fa-exclamation-circle text-slate-500'
                                                                    }`}
                                                            ></i>

                                                            <span className="text-xs hidden md:inline">
                                                                {item.uploaded_to_nextech === true
                                                                    ? 'Uploaded'
                                                                    : item.uploaded_to_nextech === false
                                                                        ? 'Not Uploaded'
                                                                        : 'Not Reviewed'}
                                                            </span>
                                                        </button>

                                                    </td>

                                                    <td className="px-2 py-1.5 text-center">
                                                        <span
                                                            onClick={() =>
                                                                !isLocked &&
                                                                item.consent_sent !== true &&
                                                                consentEmail(
                                                                    item.first_name + ' ' + item.last_name,
                                                                    item.chart,
                                                                    item.appt_id,
                                                                    item.s3_path,
                                                                    item.template
                                                                )
                                                            }
                                                            className={` inline-flex items-center justify-center w-6 h-6 md:w-8 md:h-8 rounded-full flex-shrink-0 transition-colors cursor-pointer ${item.consent_sent === true ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100'} `}
                                                            title={item.consent_sent === true ? 'Consent Sent' : 'Send Consent'}
                                                        >
                                                            <i className={`fas ${item.consent_sent === true ? 'fa-check-circle text-white' : 'fa-paper-plane text-blue-600'} text-xs md:text-sm`} ></i>
                                                        </span>
                                                    </td>



                                                    <td className="px-2 py-1.5">
                                                        <button
                                                            onClick={() =>
                                                                !isLocked &&
                                                                handleHistory(item.edited_by, item.created_at, item.created_by)
                                                            }
                                                            disabled={isLocked}
                                                            className={`
                                                          w-6 h-6 md:w-8 md:h-8 inline-flex items-center justify-center rounded-full
                                                        bg-blue-100 text-blue-800
                                                        transition-colors duration-200
                                                        hover:bg-blue-700
                                                        `}
                                                            title="History"
                                                        >
                                                            <i className="fas fa-history text-xs md:text-sm"></i>
                                                        </button>

                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={9} className="px-6 py-12 text-center">
                                                    <div className="flex flex-col items-center">
                                                        <i className="fas fa-inbox text-4xl text-gray-300 mb-3"></i>
                                                        <p className="text-gray-500 font-medium">
                                                            No surgical appointments found
                                                        </p>
                                                        <p className="text-gray-400 text-sm mt-1">
                                                            Try adjusting your filters
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        ) :
                            null
            }

            {openInjectionModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 p-4"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        !isLocked && setOpenInjectionModal(false);
                    }}>

                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full transform transition-all scale-100 hover:scale-[1.02]"
                        onClick={(e) => e.stopPropagation()}>

                        {/* Header */}
                        <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gradient-to-r from-blue-600 to-blue-700 rounded-t-2xl">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                                    <i className="fas fa-hospital text-white"></i>
                                </div>
                                <h2 className="text-lg font-semibold text-white">
                                    Populate Injection Consent Form
                                </h2>
                            </div>
                            <button
                                onClick={() => {
                                    setOpenInjectionModal(false);
                                }}
                                disabled={isLocked}
                                className="text-white/80 hover:text-white transition-colors p-1"
                            >
                                <i className="fas fa-times text-lg"></i>
                            </button>
                        </div>

                        {/* Content */}
                        <div className="p-6 space-y-4">
                            {/* Patient Info */}
                            <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                                <div className="flex items-center justify-between">
                                    <span className="text-sm text-gray-600">Chart Number</span>
                                    <span className="text-sm font-semibold text-gray-900">{modalData.chart}</span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <span className="text-sm text-gray-600">Appointment ID</span>
                                    <span className="text-sm font-semibold text-gray-900">{modalData.apptId}</span>
                                </div>
                            </div>

                            {/* Action Button */}
                            <button
                                onClick={() => !isLocked && !isSubmittingInjectionForm && injectionFormsPopulation(modalData.chart, modalData.apptId)}
                                disabled={isLocked || isSubmittingInjectionForm}
                                className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-xl hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-md flex items-center justify-center gap-2"
                            >
                                <span>{isSubmittingInjectionForm ? 'Processing...' : 'Continue to Form'}</span>
                                <i className={`fas ${isSubmittingInjectionForm ? 'fa-spinner fa-spin' : 'fa-arrow-right'}`}></i>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {openSurgicalModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 p-4"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        !isLocked && setTemplate('');
                        !isLocked && setOpenSurgicalModal(false);
                    }}>

                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full transform transition-all scale-100 hover:scale-[1.02]"
                        onClick={(e) => e.stopPropagation()}>

                        {/* Header */}
                        <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gradient-to-r from-blue-600 to-blue-700 rounded-t-2xl">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                                    <i className="fas fa-hospital text-white"></i>
                                </div>
                                <h2 className="text-lg font-semibold text-white">
                                    Populate Surgical Form
                                </h2>
                            </div>
                            <button
                                onClick={() => {
                                    setTemplate('');
                                    setOpenSurgicalModal(false);
                                }}
                                disabled={isLocked}
                                className="text-white/80 hover:text-white transition-colors p-1"
                            >
                                <i className="fas fa-times text-lg"></i>
                            </button>
                        </div>

                        {/* Content */}
                        <div className="p-6 space-y-4">
                            {/* Patient Info */}
                            <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                                <div className="flex items-center justify-between">
                                    <span className="text-sm text-gray-600">Chart Number</span>
                                    <span className="text-sm font-semibold text-gray-900">{modalData.chart}</span>
                                </div>
                                <div className="flex items-center justify-between">
                                    <span className="text-sm text-gray-600">Appointment ID</span>
                                    <span className="text-sm font-semibold text-gray-900">{modalData.apptId}</span>
                                </div>
                            </div>

                            {/* Select Dropdown */}
                            {
                                practiceForSurgery === 'rsi' ? (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Surgical Center *
                                        </label>
                                        <select
                                            value={template}
                                            onChange={(e) => !isLocked && setTemplate(e.target.value)}
                                            disabled={isLocked}
                                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:bg-gray-100 transition-all"
                                        >
                                            <option value="">Choose a surgical center</option>
                                            {surgicalLocations['rsi']?.map((location) => (
                                                <option key={location} value={location}>{location}</option>
                                            ))}
                                        </select>
                                    </div>
                                ) :
                                    null
                            }


                            {/* Action Button */}
                            <button
                                onClick={() => !isLocked && !isSubmittingSurgicalForm && ((practiceForSurgery === 'rsi' && template) || (practiceForSurgery === 'seg' && !template)) && surgicalFormsPopulation(modalData.chart, modalData.apptId, template, modalData.update_center)}
                                disabled={(practiceForSurgery === 'rsi' && !template) || isLocked || isSubmittingSurgicalForm}
                                className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-xl hover:from-blue-700 hover:to-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-md flex items-center justify-center gap-2"
                            >
                                <span>{isSubmittingSurgicalForm ? 'Processing...' : 'Continue to Form'}</span>
                                <i className={`fas ${isSubmittingSurgicalForm ? 'fa-spinner fa-spin' : 'fa-arrow-right'}`}></i>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {openHistory && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl shadow-xl p-6 w-[400px] relative">
                        <button
                            className="absolute top-2 right-3 text-gray-500 hover:text-black"
                            onClick={() => setOpenHistory(false)}
                        >
                            ✕
                        </button>

                        <h2 className="text-lg font-semibold mb-4">History</h2>

                        <p>
                            <strong>Created by:</strong> {historyData.createdBy} –{" "}
                            {historyData.createdAt}
                        </p>

                        <div className="mt-4">
                            <strong>Edited by:</strong>
                            {historyData.editedBy.length > 0 ? (
                                <ul className="list-disc ml-6 mt-2">
                                    {historyData.editedBy.map((obj, index) => {
                                        const [name, times] = Object.entries(obj)[0];
                                        return (
                                            <li key={index}>
                                                {name} – {times.join(", ")}
                                            </li>
                                        );
                                    })}
                                </ul>
                            ) : (
                                <p className="ml-2 text-gray-500">No edits yet</p>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {openPhotoChart && (
                <PhotoViewer
                    chart={openPhotoChart}
                    onClose={() => setOpenPhotoChart(null)}
                />
            )}

            {openNotificationBox && (
                <PatientNotificationPopup
                    patient={openNotificationBox}
                    config={config}
                    onClose={() => setOpenNotificationBox(null)}
                />
            )}


            <FileDownloadModal
                isOpen={openModal}
                onClose={() => setOpenModal(false)}
                data={fileData}
                isLoading={isLoading6}
                setReviewKey={setReviewKey}
            />
            <EmailPopup
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
                data={popupData}
                onSend={handleSend}
            />

            {/* Coverage Verification Modal */}
            <Modal
                isOpen={coverageModalOpen}
                onRequestClose={() => setCoverageModalOpen(false)}
                contentLabel="Coverage Verification"
                style={{
                    overlay: {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    },
                    content: {
                        position: 'relative',
                        top: 'auto',
                        left: 'auto',
                        right: 'auto',
                        bottom: 'auto',
                        maxWidth: '900px',
                        width: '90%',
                        maxHeight: '85vh',
                        overflow: 'auto',
                        borderRadius: '12px',
                        padding: '32px',
                        backgroundColor: '#ffffff',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                        border: 'none'
                    }
                }}
            >
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-3xl font-bold text-gray-900">Coverage Verification Details</h2>
                    <button
                        onClick={() => setCoverageModalOpen(false)}
                        className="text-gray-400 hover:text-gray-600 text-3xl font-bold leading-none"
                    >
                        ×
                    </button>
                </div>
                <div className="border-t border-gray-200 pt-6">
                    {coverageModalData ? (
                        <div dangerouslySetInnerHTML={{ __html: coverageModalData }} />
                    ) : (
                        <p className="text-gray-600 text-center py-8">No coverage data available</p>
                    )}
                </div>
            </Modal>

            <PCMPopup
                isOpen={showPCMPopup}
                onClose={() => {
                    setShowPCMPopup(false);
                }}
                data={pcmPopupData}
                onFillFromTab={handleFillFromTab}
                onSendCopy={handleSendCopyToPatient}
            />

            {showPCMSendPopup && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl shadow-xl p-8 w-[450px] relative">
                        <button
                            className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl"
                            onClick={() => {
                                setShowPCMSendPopup(false);
                                setShowPCMPopup(false);
                                setPcmCommunicationMedium('email');
                                setPcmPopupData({});
                            }}
                        >
                            ✕
                        </button>

                        <h2 className="text-2xl font-bold text-gray-900 mb-2">PCM Consent</h2>
                        <p className="text-sm text-gray-600 mb-6">Send PCM consent file to registered contact information</p>

                        <div className="space-y-4 mb-6">
                            <div className="bg-gray-50 p-4 rounded-lg">
                                <p className="text-xs text-gray-600 font-semibold uppercase mb-1">Patient Name</p>
                                <p className="text-sm font-medium text-gray-900">{pcmPopupData.name}</p>
                            </div>

                            <div className="bg-gray-50 p-4 rounded-lg">
                                <p className="text-xs text-gray-600 font-semibold uppercase mb-1">Chart ID</p>
                                <p className="text-sm font-medium text-gray-900">{pcmPopupData.chart}</p>
                            </div>

                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                <p className="text-xs text-gray-600 font-semibold uppercase mb-3">Communication Medium</p>
                                <div className="space-y-2">
                                    <label className="flex items-center gap-3 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="communication-medium"
                                            value="email"
                                            checked={pcmCommunicationMedium === 'email'}
                                            onChange={(e) => setPcmCommunicationMedium(e.target.value)}
                                            className="w-4 h-4 text-blue-600"
                                        />
                                        <span className="text-sm font-medium text-gray-700">Email</span>
                                    </label>
                                    <label className="flex items-center gap-3 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="communication-medium"
                                            value="mobile"
                                            checked={pcmCommunicationMedium === 'mobile'}
                                            onChange={(e) => setPcmCommunicationMedium(e.target.value)}
                                            className="w-4 h-4 text-blue-600"
                                        />
                                        <span className="text-sm font-medium text-gray-700">Mobile</span>
                                    </label>
                                </div>
                            </div>

                        </div>

                        <div className="flex gap-3">
                            <button
                                onClick={() => {
                                    setShowPCMSendPopup(false);
                                    setShowPCMPopup(false);
                                    setPcmCommunicationMedium('email');
                                    setPcmPopupData({});
                                }}
                                className="flex-1 py-2.5 bg-gray-200 text-gray-900 font-medium rounded-lg hover:bg-gray-300 transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={async () => {
                                    try {
                                        const response = await fetch(`${config.API_BASE_URL}/send_consent_link`, {
                                            method: "POST",
                                            headers: {
                                                "action_id": config.ACTIONID['view'],
                                                "Content-Type": "application/json",
                                                "Authorization": localStorage.getItem("digital-form-idtoken"),
                                                "practice": localStorage.getItem("digital-form-dept-practice")
                                            },
                                            body: JSON.stringify({
                                                data: {
                                                    appointmentid: pcmPopupData.appointmentid || pcmPopupData.appt_id,
                                                    consent: 'pcm',
                                                    communicationMedium: pcmCommunicationMedium
                                                }
                                            })
                                        });
                                        if (!response.ok) {
                                            const error = await response.json();
                                            showError('Error', error.message || 'Failed to send PCM consent.');
                                            return;
                                        }
                                        const medium = pcmCommunicationMedium === 'email' ? 'email' : 'SMS';
                                        showSuccess('Success!', `PCM consent file will be sent via ${medium}.`);
                                        setShowPCMSendPopup(false);
                                        setShowPCMPopup(false);
                                        setPcmCommunicationMedium('email');
                                        setPcmPopupData({});
                                    } catch (error) {
                                        showError('Error', 'Failed to send PCM consent.');
                                    }
                                }}
                                className="flex-1 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-medium rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all flex items-center justify-center gap-2"
                            >
                                <i className="fas fa-paper-plane"></i>
                                Send via {pcmCommunicationMedium === 'email' ? 'Email' : 'SMS'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
}

export default App;
